// File: noviopus-ats-client/src/utils/asyncInjectors.ts
import { Store } from 'redux';
import createReducer from '@/App/reducers';

export interface ExtendedStore extends Store {
  injectedReducers: Record<string, any>;
  injectReducer: (key: string | { key: string; reducer: any }, reducer?: any) => void;
  runSaga: (saga: any) => any;
  injectedSagas: Record<string, any>;
}

export function getAsyncInjectors(store: ExtendedStore) {
  return {
    injectReducer: injectReducerFactory(store),
    injectSagas: injectSagasFactory(store),
  };
}

export function injectReducerFactory(store: ExtendedStore) {
  return function injectReducer(key: string, reducer: any) {
    if (!store || !store.injectedReducers) {
        console.error('[asyncInjectors] Missing store or injectedReducers');
        return;
    }

    if (Reflect.has(store.injectedReducers, key) && store.injectedReducers[key] === reducer) {
      return;
    }

    store.injectedReducers[key] = reducer;
    // FIX: createReducer only accepts injectedReducers now
    store.replaceReducer(createReducer(store.injectedReducers));
  };
}

export function injectSagasFactory(store: ExtendedStore) {
  return function injectSagas(sagas: any) {
    if (!store.injectedSagas) {
        store.injectedSagas = {};
    }

    const sagaArray = Array.isArray(sagas) ? sagas : [sagas];

    sagaArray.forEach((saga: any) => {
        if (!saga) return;
        const targetSaga = saga.default || saga;
        const sagaName = targetSaga.name || targetSaga.toString();

        if (store.injectedSagas[sagaName]) {
            return;
        }

        store.injectedSagas[sagaName] = true;
        
        try {
            store.runSaga(targetSaga);
        } catch (error) {
            console.error(`[asyncInjectors] Failed to run saga: ${sagaName}`, error);
        }
    });
  };
}
